import { render, staticRenderFns } from "./providerSetupList.vue?vue&type=template&id=20298126&"
import script from "./providerSetupList.vue?vue&type=script&lang=js&"
export * from "./providerSetupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports